// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import type { Artifact, PolicyDetail } from '../types/procedures';

interface UpstreamFiles {
  policy?: string;
  data?: string;
  tests?: string;
}

/**
 * Maps a real `Artifact` envelope to the policy view/create screens'
 * normalized shape — the `PolicyPayload` (policy-as-code) counterpart of
 * `toProcedureDetail()`.
 */
export function toPolicyDetail(artifact: Artifact): PolicyDetail {
  const payload = artifact.payload ?? {};
  const categories = artifact.categories ?? {};
  const files = (payload.files ?? {}) as UpstreamFiles;

  return {
    artifactId: artifact.artifact_id ?? '',
    artifactType: artifact.artifact_type ?? '',
    title: artifact.title ?? '',
    policyNumber: artifact.artifact_id ?? '',
    version: artifact.version ?? '',
    status: artifact.status ?? '',
    classification: categories.domain ?? '',
    policyDomain: (categories.policy_domain as string) ?? '',
    scope: (categories.scope as string) ?? '',
    enforcementPoint: (categories.enforcement_point as string) ?? '',
    decisionSummary: (payload.decision_summary as string) ?? '',
    package: (payload.package as string) ?? '',
    files: {
      policy: files.policy ?? '',
      data: files.data ?? '',
      tests: files.tests ?? '',
    },
  };
}
